import PreHeading from '@/components/elements/PreHeading';
import StoryblokLink from '@/components/elements/StoryblokLink';

function dropdownListPrimary({ dropdown }) {
  return (
    <div key={dropdown._uid} className="space-y-2">
      {dropdown.heading && (
        <PreHeading size="xs" element="p">
          {dropdown.heading}
        </PreHeading>
      )}
      <ul className="space-y-2">
        {dropdown.navigation_items?.map((navItem) => (
          <li key={navItem._uid}>
            <StoryblokLink link={navItem.page} passHref={true}>
              <a className="text-lg font-medium text-neutral-700 hover:text-rose-600 dark:text-neutral-300 dark:hover:text-rose-600 lg:text-xl">
                {navItem.label ? navItem.label : navItem.page.story.name}
              </a>
            </StoryblokLink>
          </li>
        ))}
      </ul>
    </div>
  );
}
export default dropdownListPrimary;
